import {ConnectBilling, ConnectBillingContract} from './index';

function mapInvoiceCoupon(
  contract: ConnectBillingContract.InvoiceCoupon,
): ConnectBilling.InvoiceCoupon {
  const {id, amount_off_usd, percent_off} = contract;
  switch (contract.duration) {
    case 'repeating': {
      return {
        id,
        amountOff: amount_off_usd,
        percentOff: percent_off,
        duration: contract.duration,
        month: contract.duration_in_month,
      };
    }

    default:
      return {
        id,
        amountOff: amount_off_usd,
        percentOff: percent_off,
        duration: contract.duration,
      };
  }
}

function mapDiscount(contract: ConnectBillingContract.Discount): ConnectBilling.Discount {
  const {amount_usd, coupon} = contract;

  return {
    amount: amount_usd,
    coupon: mapInvoiceCoupon(coupon),
  };
}

function mapInvoice(c: ConnectBillingContract.Invoice): ConnectBilling.Invoice {
  return {
    date: c.issuance_at,
    hours: c.meeting_hours,
    subscription: c.subscription_fee_usd,
    usage: c.usage_fee_usd,
    total: c.total_period_amount_usd,
    discounts: c.discounts?.map(mapDiscount) ?? [],
  };
}

function mapHistory(c: ConnectBillingContract.History): ConnectBilling.History {
  return {
    invoice: c.upcoming_info ? mapInvoice(c.upcoming_info) : undefined,
    history: c.history,
  };
}

function mapTier(contract: ConnectBillingContract.Tier): ConnectBilling.Tier {
  return {
    id: contract.id,
    name: contract.name,
    subscriptionFee: contract.subscription_fee_usd ?? 0,
    hourlyRate: contract.hourly_rate ?? 0,
    interval: {
      count: contract.billing_period.count,
      dimension: contract.billing_period.interval,
    },
    custom: contract.is_custom,
    limit: contract.limitations.max_participants,
  };
}

export const connectBillingMapper = {mapHistory, mapTier};
